<div class="p-8 w-100">
    <div class="d-flex justify-content-between align-items-start gap-4">
        <div class="fs-2 fw-bolder text-dark">
            <i class="fas fa-calculator text-primary fs-3 me-1"></i> {{ 'INDEXED_PRICE_FORMULA_TITLE' | translate }}
        </div>
        <button class="btn btn-sm btn-icon btn-light" [attr.aria-label]="'CLOSE' | translate" (click)="close()">
            <i class="fas fa-times"></i>
        </button>
    </div>
    <div class="fs-7 text-muted mt-2"> {{ 'INDEXED_PRICE_FORMULA_DESCRIPTION' | translate }} </div>

    <!-- START: Formula -->
    <div class="formula rounded bg-light-primary text-dark text-center fs-6 fw-semibold py-4 px-3 mt-5">
        {{ 'INDEXED_PRICE' | translate }} =
        (<span class="formula-term">OMIP</span>
        × <span class="formula-term">{{ 'INDEXED_PRICE_PROFILE_FACTOR' | translate }}</span>
        + <span class="formula-term">{{ 'INDEXED_PRICE_SYSTEM_COSTS' | translate }}</span>)
        × (1 + <span class="formula-term">{{ 'INDEXED_PRICE_LOSSES' | translate }}</span>)
        + <span class="formula-term">{{ 'INDEXED_PRICE_SUPPLIER_FEE' | translate }}</span>
    </div>
    <!-- END: Formula -->

    <!-- START: Factors -->
    <div class="fs-5 fw-bold text-dark mt-6"> {{ 'INDEXED_PRICE_FORMULA_FACTORS_TITLE' | translate }} </div>

    <div class="factor mt-3">
        <div class="factor-icon"><i class="fas fa-chart-line"></i></div>
        <div class="flex-grow-1">
            <div class="d-flex flex-wrap justify-content-between align-items-baseline gap-2">
                <span class="fw-bold text-dark fs-6"> OMIP </span>
                <span class="badge badge-light text-gray-700 fs-8"> €/MWh </span>
            </div>
            <div class="fs-7 text-muted mt-1"> {{ 'INDEXED_PRICE_OMIP_DESCRIPTION' | translate }} </div>
        </div>
    </div>

    <div class="factor mt-3">
        <div class="factor-icon"><i class="fas fa-clock"></i></div>
        <div class="flex-grow-1">
            <span class="fw-bold text-dark fs-6"> {{ 'INDEXED_PRICE_PROFILE_FACTOR' | translate }} </span>
            <div class="fs-7 text-muted mt-1"> {{ 'INDEXED_PRICE_PROFILE_FACTOR_DESCRIPTION' | translate }} </div>
            <div class="d-flex flex-wrap gap-2 mt-2">
                <span *ngFor="let coefficient of profileCoefficients" class="badge badge-light text-gray-700 fs-8 fw-semibold">
                    {{ coefficient.labelKey | translate }} × {{ coefficient.value | number:'1.2-2' }}
                </span>
            </div>
        </div>
    </div>

    <div class="factor mt-3">
        <div class="factor-icon"><i class="fas fa-tower-broadcast"></i></div>
        <div class="flex-grow-1">
            <div class="d-flex flex-wrap justify-content-between align-items-baseline gap-2">
                <span class="fw-bold text-dark fs-6"> {{ 'INDEXED_PRICE_SYSTEM_COSTS' | translate }} </span>
                <span class="badge badge-light text-gray-700 fs-8"> {{ IndexedPriceEstimate.SYSTEM_COSTS | number:'1.2-2' }} €/MWh </span>
            </div>
            <div class="fs-7 text-muted mt-1"> {{ 'INDEXED_PRICE_SYSTEM_COSTS_DESCRIPTION' | translate }} </div>
        </div>
    </div>

    <div class="factor mt-3">
        <div class="factor-icon"><i class="fas fa-plug-circle-minus"></i></div>
        <div class="flex-grow-1">
            <span class="fw-bold text-dark fs-6"> {{ 'INDEXED_PRICE_LOSSES' | translate }} </span>
            <div class="fs-7 text-muted mt-1"> {{ 'INDEXED_PRICE_LOSSES_DESCRIPTION' | translate }} </div>
            <div class="d-flex flex-wrap gap-2 mt-2">
                <span *ngFor="let lossFactor of lossFactors" class="badge badge-light text-gray-700 fs-8 fw-semibold">
                    {{ lossFactor.tensionLevel }} · {{ lossFactor.value | percent:'1.1-1' }}
                </span>
            </div>
        </div>
    </div>

    <div class="factor mt-3">
        <div class="factor-icon"><i class="fas fa-handshake"></i></div>
        <div class="flex-grow-1">
            <div class="d-flex flex-wrap justify-content-between align-items-baseline gap-2">
                <span class="fw-bold text-dark fs-6"> {{ 'INDEXED_PRICE_SUPPLIER_FEE' | translate }} </span>
                <span class="badge badge-light text-gray-700 fs-8"> {{ IndexedPriceEstimate.SUPPLIER_FEE | number:'1.2-2' }} €/MWh </span>
            </div>
            <div class="fs-7 text-muted mt-1"> {{ 'INDEXED_PRICE_SUPPLIER_FEE_DESCRIPTION' | translate }} </div>
        </div>
    </div>
    <!-- END: Factors -->

    <!-- START: Calculation -->
    <ng-container *ngIf="formulaValues">
        <div class="fs-5 fw-bold text-dark mt-6"> {{ 'INDEXED_PRICE_FORMULA_YEARS_TITLE' | translate }} </div>
        <div class="rounded border border-dashed border-gray-300 bg-light py-3 px-4 mt-3 fs-7">
            <div class="formula text-muted py-1">
                ({{ formulaValues.averageOmip | number:'1.2-2' }} × {{ formulaValues.averageProfileFactor | number:'1.3-3' }}
                + {{ IndexedPriceEstimate.SYSTEM_COSTS | number:'1.2-2' }})
                × (1 + {{ formulaValues.averageLossFactor | percent:'1.1-1' }})
                + {{ IndexedPriceEstimate.SUPPLIER_FEE | number:'1.2-2' }}
                ≈ <span class="fw-bold text-dark">{{ formulaValues.averageIndexedPrice | number:'1.2-2' }} €/MWh</span>
            </div>
        </div>
    </ng-container>
    <!-- END: Calculation -->

    <div class="fs-8 text-muted mt-3">
        <i class="fas fa-circle-info me-1"></i> {{ 'INDEXED_PRICE_FORMULA_FOOTNOTE' | translate }}
    </div>

    <div class="d-flex justify-content-end mt-6">
        <button class="btn btn-primary" (click)="close()"> {{ 'CLOSE' | translate }} </button>
    </div>
</div>
